<template>
  <generic-modal
    size="small"
    :title="$t('movement type configuration')"
    icon="exchange"
    image="/images/icons/branch.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h4 class="ui dividing header">
          <i class="info icon"></i>
          {{ $t("general info") }}
        </h4>
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="type.name" />
        </div>
        <h4 class="ui dividing header">
          <i class="settings icon"></i>
          {{ $t("settings") }}
        </h4>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("default amount") }}</label>
            <input
              type="text"
              name="default_amount"
              v-model="type.setup.default_amount"
            />
          </div>
          <div class="field">
            <label for>{{ $t("movement nature") }}</label>
            <div class="ui toggle checkbox" ref="affect_checkbox">
              <input type="checkbox" />
              <label>{{ affect_title }}</label>
            </div>
          </div>
        </div>

        <div class="ui message error"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api /*, stringify */ } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  name: "MovementTypeModal",
  components: {
    "generic-modal": GenericModal,
  },
  props: {
    type_in: Object,
  },
  computed: {},
  data() {
    return {
      affect_title: "",
      type: {
        uuid: "",
        name: "",
        setup: {
          default_amount: "",
          affect: "",
        },
      },
    };
  },
  methods: {
    updateTitle() {
      switch (this.type.setup.affect) {
        case "C":
          this.affect_title = this.$t("credit");
          break;
        case "N":
          this.affect_title = this.$t("neither");
          break;
        case "D":
        default:
          this.affect_title = this.$t("debit");
          break;
      }
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          local_api(vm, "post", "/account_movement_type/do-save", {
            u: vm.type.uuid,
            n: vm.type.name,
            s: vm.type.setup,
          })
            .then((response) => {
              vm.$emit("updated", response);
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
  },
  created() {
    if (this.type_in) {
      this.type.uuid = this.type_in.uuid;
      this.type.name = this.type_in.name;
      if (this.type_in.setup) {
        if (typeof this.type_in.setup == "object")
          this.type.setup = this.type_in.setup;
        else if (typeof this.type_in.setup == "string")
          this.type.setup = JSON.parse(this.type_in.setup);
        this.updateTitle();
      }
    }
  },
  mounted() {
    let vm = this;

    window.jQuery(".ui.menu .item").tab();
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
      },
    });

    window.jQuery(vm.$refs.affect_checkbox).checkbox({
      beforeChecked() {
        let isIndeterminated = window
          .jQuery(vm.$refs.affect_checkbox)
          .hasClass("indeterminate");
        if (!isIndeterminated) {
          window.jQuery(vm.$refs.affect_checkbox).checkbox("set indeterminate");
          vm.type.setup.affect = "N";
          vm.updateTitle();
          return false;
        }
      },
      onChecked() {
        vm.type.setup.affect = "C";
        vm.updateTitle();
      },
      onUnchecked() {
        vm.type.setup.affect = "D";
        vm.updateTitle();
      },
    });

    /** Set checkbox */
    if (vm.type.setup.affect == "C") {
      window.jQuery(vm.$refs.affect_checkbox).checkbox("set checked");
    } else if (vm.type.setup.affect == "D") {
      window.jQuery(vm.$refs.affect_checkbox).checkbox("set unchecked");
    } else if (vm.type.setup.affect == "N") {
      window.jQuery(vm.$refs.affect_checkbox).checkbox("set indeterminate");
    }
  },
  watch: {
    "type.setup.affect": () => {
      if (this) console.log(this.type.setup.affect);
    },
  },
  updated: function() {},
};
</script>
